export const fontSizes = {
  'xxs': '0.625rem',
  'xs': '0.75rem',
  'sm': '0.875rem',
  'md': '1rem',
  'lg': '1.125rem',
  'xl': '1.25rem',
  '2xl': '1.5rem',
  '3xl': '1.625rem',
  '4xl': '1.875rem',
} as const
